import React from 'react';
import styles from 'styles/components/loginWithGoogle.module.scss';

const LoginWithSlack = ({ isLogin = true, refParam }) => (
  <a
    href={`https://performance-management-api.buddieshr.com/web-app/auth/${
      isLogin ? 'login-with-slack' : 'register-with-slack'
    }${refParam && refParam.length > 0 ? `?ref=${refParam}` : ''}`}
  >
    <button
      className={`${styles.gsiMaterialButton} ${styles.slackButton}`}
      style={{
        width: '100%',
      }}
    >
      <div className={styles.gsiMaterialButtonState}></div>
      <div className={styles.gsiMaterialButtonContentWrapper}>
        <div className={styles.gsiMaterialButtonIcon}>
          <img src="/img/slack_80.png" alt="slack" width={20} height={20} />
        </div>
        <span className={styles.gsiMaterialButtonContents}>
          {isLogin ? 'Sign in with Slack' : 'Sign up with Slack'}
        </span>
      </div>
    </button>
  </a>
);

export default LoginWithSlack;
